import { useState } from "react";

import LabeledInput from "@/react/components/LabeledInput";
import PageTitle from "@/react/components/PageTitle";
import { CustomerCard } from "@/react/features/customer";
import PageContentContainer from "@/react/features/styled/PageContentContainer";
import PageLayout from "@/react/features/styled/PageLayout";
import { useErrorNotification } from "@/react/notifications";

import TableWrapper from "@/react/features/styled/TableWrapper";
import TableComponent from "@/react/components/table/TableComponent";
import { filterTableMutations } from "@/react/components/table/filterTableMutations";
import { useTable } from "@/react/components/table/useTable";

import columnDefinition from "./columnDefinition";
import schema from "./schema";
import { DidInputContainer, ErrorMessage } from "./styled";
import { useDidActions } from "./useDidActions";

const columns = columnDefinition();

const UnbindVmmsPage = () => {
  const [enteredDid, setEnteredDid] = useState(null);
  const [formatError, setFormatError] = useState(false);
  const [unbindData, setUnbindData] = useState([]);

  const { sanitizeDid, unbindDid, processingUnbindRequest, error } =
    useDidActions(setFormatError, setUnbindData);

  useErrorNotification(error);

  const { table, filters, state, mutations } = useTable(
    unbindData,
    columns,
    schema,
    schema.fields.step.spec.key
  );

  const finalMutations = filterTableMutations(mutations);

  const checkDid = (event) => {
    const { valid } = sanitizeDid(event.target.value);
    return valid;
  };

  const handleUnbindRequest = (event) => {
    const { sanitizedDid } = sanitizeDid(enteredDid);
    unbindDid(sanitizedDid);
  };

  return (
    <PageLayout>
      <CustomerCard hasPbxSelector={true} />
      <PageContentContainer>
        <PageTitle>Unbind VMMS DID</PageTitle>
        <DidInputContainer>
          <LabeledInput
            prompt={"Phone Number"}
            placeholder={"ex: 8001234444, 800-123-4444, (800) 123-4444"}
            value={enteredDid ?? ""}
            setValue={setEnteredDid}
            onSubmit={handleUnbindRequest}
            validator={checkDid}
            hasError={formatError}
            allowInvalidInput
            submitOnEnter
            includeButton
            buttonText={"Unbind"}
          />
          {formatError && (
            <ErrorMessage>
              DID must be numeric and contain at least 8 numerals
            </ErrorMessage>
          )}
        </DidInputContainer>
        <TableWrapper>
          <TableComponent
            title="Unbind VMMS DID"
            schema={schema}
            isDirty={false}
            isLoading={processingUnbindRequest}
            onSave={null}
            onCancel={null}
            onRefresh={null}
            table={table}
            filters={filters}
            mutations={finalMutations}
            state={state}
          />
        </TableWrapper>
      </PageContentContainer>
    </PageLayout>
  );
};

export default UnbindVmmsPage;
